const Unauthorised = () => {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      Unauthorised access. <br />
      You do not have permission to view this page.
    </div>
  );
};

export default Unauthorised;
